import { render, staticRenderFns } from "./PatientAllergyRep.vue?vue&type=template&id=64d3dbb4&"
import script from "./PatientAllergyRep.vue?vue&type=script&lang=js&"
export * from "./PatientAllergyRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientAllergyRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports